/**
 * Food Specialties Components
 * Exports all food specialties related components
 */

export { FoodSpecialtyItem } from './FoodSpecialtyItem';
export { FoodSpecialtiesSection } from './FoodSpecialtiesSection';

// Export types
export type {
  FoodSpecialtyItemProps,
  FoodSpecialty,
} from './FoodSpecialtyItem';
export type { FoodSpecialtiesSectionProps } from './FoodSpecialtiesSection';
